function adjustCardSizes() {
    document.querySelectorAll('.flip-card-rectangular').forEach(flipCardWidget => {
        let backBigger = false;
        let maxHeight = 0;

        flipCardWidget.querySelectorAll('.flip-card-rectangular-item').forEach(card => {
            const front = card.querySelector('.flip-card-rectangular-item-content.front');
            const back = card.querySelector('.flip-card-rectangular-item-content.back');
            
            front.style.height = "auto";
            back.style.height = "auto";
        });

        Array.from(flipCardWidget.querySelectorAll('.flip-card-rectangular-item')).forEach(card => {
            const front = card.querySelector('.flip-card-rectangular-item-content.front');
            const back = card.querySelector('.flip-card-rectangular-item-content.back');
    
            let frontHeight = front.scrollHeight >= back.scrollHeight
                ? front.scrollHeight
                : front.scrollHeight + 90;
            let backHeight = front.scrollHeight >= back.scrollHeight
                ? back.scrollHeight
                : back.scrollHeight + 90;

            if (backHeight > frontHeight && !backBigger)
                backBigger = true;
    
            const cardMaxHeight = Math.max(frontHeight, backHeight);
            maxHeight = Math.max(maxHeight, cardMaxHeight);
        });

        // if (!backBigger)
        //     return;

        flipCardWidget.querySelectorAll('.flip-card-rectangular-item').forEach(card => {
            const front = card.querySelector('.flip-card-rectangular-item-content.front');
            const back = card.querySelector('.flip-card-rectangular-item-content.back');
    
            front.style.height = `${maxHeight}px`;
            back.style.height = `${maxHeight}px`;
        });
    });
}

window.onload = adjustCardSizes;
window.onresize = adjustCardSizes;